import React from "react";
import { useLang } from "../../lib/LangContext";

export default function Footer() {
  const { dict } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1918] text-[#F7F5F0] pt-20 pb-10 border-t border-[#F7F5F0]/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div
          className="serif font-light leading-[0.86] tracking-[-0.03em]"
          style={{ fontSize: "clamp(56px, 12vw, 220px)" }}
        >
          {dict.footer_company_full.split(".")[0]}
          <span className="italic text-[#B56B45]">.</span>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 border-t border-[#F7F5F0]/15 pt-10">
          <div className="col-span-12 md:col-span-4">
            <div className="label text-[10px] text-[#EAE6DF]/70 mb-3">{dict.footer_company}</div>
            <div className="serif text-xl">{dict.footer_company_full}</div>
            <div className="text-[#EAE6DF]/70 text-sm mt-2">{dict.footer_company_sub}</div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="label text-[10px] text-[#EAE6DF]/70 mb-3">{dict.footer_navigate}</div>
            <div className="flex flex-col gap-2 serif text-lg">
              <a href="#manifesto" className="link-under w-fit">
                {dict.nav_manifesto}
              </a>
              <a href="#catalogue" className="link-under w-fit">
                {dict.nav_catalogue}
              </a>
              <a href="#sustainability" className="link-under w-fit">
                {dict.nav_sustainability}
              </a>
              <a href="#contact" className="link-under w-fit">
                {dict.nav_contact}
              </a>
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="label text-[10px] text-[#EAE6DF]/70 mb-3">{dict.footer_families}</div>
            <div className="flex flex-col gap-2 serif text-lg">
              <a href="#paper" className="link-under w-fit">
                {dict.cat_paper_title}
              </a>
              <a href="#aluminium" className="link-under w-fit">
                {dict.cat_aluminium_title}
              </a>
              <a href="#wooden" className="link-under w-fit">
                {dict.cat_wooden_title}
              </a>
              <a href="#hygiene" className="link-under w-fit">
                {dict.cat_hygiene_title}
              </a>
              <a href="#plastic" className="link-under w-fit">
                {dict.cat_plastic_title}
              </a>
            </div>
          </div>
          <div className="col-span-12 md:col-span-2">
            <div className="label text-[10px] text-[#EAE6DF]/70 mb-3">{dict.footer_colophon}</div>
            <div className="text-sm text-[#EAE6DF]/70 leading-relaxed">
              {dict.footer_colophon_body}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.24em] uppercase text-[#EAE6DF]/60">
          <span>{dict.footer_copyright(new Date().getFullYear())}</span>
          <span>{dict.footer_volume}</span>
          <a href="#top" className="link-under">
            {dict.footer_back}
          </a>
        </div>
      </div>
    </footer>
  );
}
